import React from "react";
import {ActivityIndicator, View, Text} from "react-native";
import styles from './pt-activity-indicator-styles';

export default function PtActivityIndicator({show, message}: {show: boolean; message?: string;}) {
  if(show) {
    return (
      <View style={styles.activityIndicatorContainer}>
        <View style={styles.activityIndicatorWrapper}>
          <ActivityIndicator size={`large`} color={`#005691`}/>
          {message ? <Text>{message}</Text> : null}
        </View>
      </View>
    )
  } else {
    return (
      <View/>
    )
  }
}

PtActivityIndicator.defaultProps = {
  show:  false,
  message: null
};
